import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';
import { get as _get } from 'lodash';
import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { reduxStateMap, withReducerName } from '../redux/reduxMap';
import { saveInputValueToRedux } from '../redux/registryActions';

const useStyles = makeStyles((theme) => ({
    formControl: {
        marginTop: 'auto',
        marginBottom: 'auto',
        width: '100%'
    },
    selectEmpty: {
        marginTop: theme.spacing(2)
    },
    selectInputBase: {
        height: '55px !important'
    }
}));

function Dropdown({ items = [], label, propertyKey }) {
    const classes = useStyles();
    const [value, setValue] = React.useState(JSON.parse(localStorage.getItem(propertyKey) || 'null'));

    const inputLabel = React.useRef(null);
    const [labelWidth, setLabelWidth] = React.useState(0);
    const dispatch = useDispatch();
    React.useEffect(() => {
        setLabelWidth(inputLabel.current.offsetWidth);
    }, []);

    const handleChange = (event) => {
        setValue(event.target.value);
        localStorage.setItem(propertyKey, event.target.value);
        dispatch(saveInputValueToRedux(propertyKey, event.target.value));
    };

    return (
        <FormControl variant="outlined" className={classes.formControl}>
            <InputLabel ref={inputLabel} style={{ lineHeight: '16x' }}>
                {label}
            </InputLabel>
            <Select value={value} onChange={handleChange} labelWidth={labelWidth} className={classes.selectInputBase} MenuProps={{ disableScrollLock: true }}>
                {items.map((item, idx) => {
                    if (item.disabled && value === item.value) {
                        // unset the value if the user has no access to this item
                        setValue(null);
                        dispatch(saveInputValueToRedux(propertyKey, null));
                    }
                    return (
                        <MenuItem key={idx} value={item.value} disabled={item.disabled}>
                            {item.label}
                        </MenuItem>
                    );
                })}
            </Select>
        </FormControl>
    );
}

//export const QueryTypeDropdown = connect((state) => ({ configuration: _get(state, withReducerName(reduxStateMap.CONFIGURATION), {}) }))(({ configuration }) => {
//    const queryTypeEntries = (configuration && configuration.QueryTypes && Object.entries(configuration.QueryTypes)) || [];
//    const items = queryTypeEntries.map(([key, value]) => {
//        const queryIsAllowed = configuration.AllowedQueries.some((v) => v.toString() === key);
//        return { value: key, label: value, disabled: !queryIsAllowed };
//    });
//    return <Dropdown items={items} label="Raportti" propertyKey={reduxStateMap.QUERY_TYPE} />;
//});

export const QueryTypeDropdown = connect((state) => ({ configuration: _get(state, withReducerName(reduxStateMap.CONFIGURATION), {}) }))(({ configuration }) => {
    const queryTypeEntries = (configuration?.QueryTypes && Object.entries(configuration.QueryTypes)) || [];

    const allowedQueryKeys = configuration?.AllowedQueries?.map((v) => v.toString()) || [];

    const items = queryTypeEntries
        .filter(([key]) => allowedQueryKeys.includes(key)) // Only include allowed queries
        .map(([key, value]) => ({
            value: key,
            label: value
        }));

    return <Dropdown items={items} label="Raportti" propertyKey={reduxStateMap.QUERY_TYPE} />;
});

export const VehicleTypeDropdown = connect((state) => ({ configuration: _get(state, withReducerName(reduxStateMap.CONFIGURATION), {}) }))(({ configuration }) => {
    const vehicleTypeEntries = (configuration && configuration.VehicleTypes && Object.entries(configuration.VehicleTypes)) || [];
    const items = vehicleTypeEntries.map(([key, value]) => ({ value: key, label: value }));
    return <Dropdown items={items} label="Ajoneuvoluokka" propertyKey={reduxStateMap.VEHICLE_TYPE} />;
});
